<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="
					selectedUrl ? `master/academic-calendar/${inputs.id}` : `master/academic-calendar`
				"
			>
				<div class="form-group row align-items-center">
					<label for="inputs_academic_calendar_name" class="col-sm-3 mb-0">
						Academic Calendar Name
					</label>
					<app-input
						id="inputs_academic_calendar_name"
						class="col-sm-9"
						type="text"
						v-model="inputs.academic_calendar_name"
						:placeholder="'Academic Calendar Name'"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<div class="col-sm-12 mb-0" style="border-top: 2px solid #399dc4;padding-top: 10px;">
					</div>
					<label for="inputs_term" class="col-sm-3 mb-0">
						Term
					</label>
					<app-input
						id="inputs_term"
						class="col-sm-2"
						type="number"
						v-model="inputs.term"
						:placeholder="'term'"
						:required="true"
					/>
					<label for="inputs_school_year_from" class="col-sm-2 mb-0">
						School Year
					</label>
					<app-input
						id="inputs_school_year_from"
						class="col-sm-2"
						type="number"
						v-model="inputs.school_year_from"
						:placeholder="'From'"
						:required="true"
					/>
					<app-input 
						id="inputs_school_year_to"
						class="col-sm-2"
						type="number"
						v-model="inputs.school_year_to"
						:placeholder="'To'"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<div class="col-sm-12 mb-0" style="border-top: 2px solid #399dc4;padding-top: 10px;">
					</div>
					<label for="inputs_date_start" class="col-sm-3 mb-0">
						Date Start (Semester)
					</label>
					<app-input
						id="inputs_date_start"
						class="col-sm-9"
						type="date"
						v-model="inputs.date_start"
						:placeholder="'Date Start (Semester)'"
						:required="true"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_date_end" class="col-sm-3 mb-0">
						Date End (Semester)
					</label>
					<app-input
						id="inputs_date_end"
						class="col-sm-9"
						type="date"
						v-model="inputs.date_end"
						:placeholder="'Date End (Semester)'"
						:required="true"
					/>
				</div>
				
				<div class="form-group row align-items-center">
					<label for="inputs_date_start_next_class" class="col-sm-3 mb-0">
						Date Start (Next Class)
					</label>
					<app-input
						id="inputs_date_start_next_class"
						class="col-sm-9"
						type="date"
						v-model="inputs.date_start_next_class"
						:placeholder="'Date Start (Next Class)'"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_date_end_next_class" class="col-sm-3 mb-0">
						Date End (Next Class)
					</label>
					<app-input
						id="inputs_date_end_next_class"
						class="col-sm-9"
						type="date"
						v-model="inputs.date_end_next_class"
						:placeholder="'Date End (Next Class)'"
					/>
				</div>
				
				<div class="form-group row align-items-center">
					<label for="inputs_date_start_sc_conform" class="col-sm-3 mb-0">
						Date Start (SC Conform)
					</label>
					<app-input
						id="inputs_date_start_sc_conform"
						class="col-sm-9"
						type="date"
						v-model="inputs.date_start_sc_conform"
						:placeholder="'Date Start (SC Conform)'"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_date_end_sc_conform" class="col-sm-3 mb-0">
						Date End (SC Conform)
					</label>
					<app-input
						id="inputs_date_end_sc_conform"
						class="col-sm-9"
						type="date"
						v-model="inputs.date_end_sc_conform"
						:placeholder="'Date End (SC Conform)'"
					/>
				</div>
				<div class="form-group row align-items-center">
					<div class="col-sm-12 mb-0" style="border-top: 2px solid #399dc4;padding-top: 10px;">
					</div>
					<label for="inputs_early_bird_discount" class="col-sm-3 mb-0">
						Early Bird Discount
					</label>
					<app-input
						id="inputs_early_bird_discount"
						class="col-sm-9"
						type="text"
						v-model="input_early_bird_discount"
						@input="onInputEarlyBirdDiscount"
						placeholder="Early Bird Discount"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_date_start_early_bird" class="col-sm-3 mb-0">
						Date Start (Early Bird)
					</label>
					<app-input
						id="inputs_date_start_early_bird"
						class="col-sm-9"
						type="date"
						v-model="inputs.date_start_early_bird"
						:placeholder="'Date Start (Early Bird)'"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_date_end_early_bird" class="col-sm-3 mb-0">
						Date End (Early Bird)
					</label>
					<app-input
						id="inputs_date_end_early_bird"
						class="col-sm-9"
						type="date"
						v-model="inputs.date_end_early_bird"
						:placeholder="'Date End (Early Bird)'"
					/>
				</div>
				<div class="form-group row align-items-center">
					<div class="col-sm-12 mb-0" style="border-top: 2px solid #399dc4;padding-top: 10px;">
					</div>
					<label for="inputs_date_start_normal" class="col-sm-3 mb-0">
						Date Start (Normal)
					</label>
					<app-input
						id="inputs_date_start_normal"
						class="col-sm-9"
						type="date"
						v-model="inputs.date_start_normal"
						:placeholder="'Date Start (Normal)'"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_date_end_normal" class="col-sm-3 mb-0">
						Date End (Normal)
					</label>
					<app-input
						id="inputs_date_end_normal"
						class="col-sm-9"
						type="date"
						v-model="inputs.date_end_normal"
						:placeholder="'Date End (Normal)'"
					/>
				</div>
				
				<div class="form-group row align-items-center">
					<div class="col-sm-12 mb-0" style="border-top: 2px solid #399dc4;padding-top: 10px;">
					</div>
					<label for="inputs_late_charges_fee" class="col-sm-3 mb-0">
						Late Charges Fee
					</label>	
					<app-input
						id="inputs_late_charges_fee"
						class="col-sm-9"
						type="text"
						v-model="input_late_charges_fee"
						@input="onInputLateChargesFee"
						placeholder="Late Charges Fee"
					/>
				</div>
				
				<div class="form-group row align-items-center">
					<label for="inputs_date_start_late_charges" class="col-sm-3 mb-0">
						Date Start<br>(Late Charges)
					</label>
					<app-input
						id="inputs_date_start_late_charges"
						class="col-sm-9"
						type="date"
						v-model="inputs.date_start_late_charges"
						:placeholder="'Date Start (Early Bird)'"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_date_end_late_charges" class="col-sm-3 mb-0">
						Date End<br>(Late Charges)
					</label>
					<app-input
						id="inputs_date_end_late_charges"
						class="col-sm-9"
						type="date"
						v-model="inputs.date_end_late_charges"
						:placeholder="'Date End (Late Charges)'"
					/>
				</div>
				
				<div class="form-group row align-items-center">
					<label for="inputs_date_start_discontinue" class="col-sm-3 mb-0">
						Date Start<br>(Discontinue)
					</label>
					<app-input
						id="inputs_date_start_discontinue"
						class="col-sm-9"
						type="date"
						v-model="inputs.date_start_discontinue"
						:placeholder="'Date Start (Discontinue)'"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_date_end_discontinue" class="col-sm-3 mb-0">
						Date End<br>(Discontinue)
					</label>
					<app-input
						id="inputs_date_end_discontinue"
						class="col-sm-9"
						type="date"
						v-model="inputs.date_end_discontinue"
						:placeholder="'Date End (Discontinue)'"
					/>
				</div>
				
				<div class="form-group row align-items-center">
					<label for="inputs_date_start_terminated" class="col-sm-3 mb-0">
						Date Start<br>(Terminated)
					</label>
					<app-input
						id="inputs_date_start_terminated"
						class="col-sm-9"
						type="date"
						v-model="inputs.date_start_terminated"
						:placeholder="'Date Start (Terminated)'"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_date_end_terminated" class="col-sm-3 mb-0">
						Date End<br>(Terminated)
					</label>
					<app-input
						id="inputs_date_end_terminated"
						class="col-sm-9"
						type="date"
						v-model="inputs.date_end_terminated"
						:placeholder="'Date End (Terminated)'"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_is_active" class="col-sm-3 mb-0">
						&nbsp;
					</label>
					<div class="col-sm-8">
						<app-input
							id="inputs_is_active"
							:list-value-field="$t('is_active')"
							type="single-checkbox"
							v-model="inputs.is_active"
						/>
					</div>
				</div>
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../Mixins/ModalMixin";
export default {
	name: "ModalForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
	},
	data() {
		return {
			preloader: false,
			inputs: {
				term:'',
				school_year_to: '',
				school_year_from :'',
				early_bird_discount: 0,
				late_charges_fee: 0,
			},
			// nilai tampilan (diformat Rp)
			input_early_bird_discount: "",
			input_late_charges_fee: "",
			modalId: this.formId,
			modalTitle: this.$t("add"),
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}
	},
	methods: {
		onInputEarlyBirdDiscount(value) {
			// value sudah string angka
			value = value.replace(/[^\d]/g, "");
			this.inputs.early_bird_discount = Number(value || 0);
			this.input_early_bird_discount = this.formatRupiah(value);
		},

		onInputLateChargesFee(value) {
			value = value.replace(/[^\d]/g, "");
			this.inputs.late_charges_fee = Number(value || 0);
			this.input_late_charges_fee = this.formatRupiah(value);
		},


		// ====== Formatter Rupiah ======
		formatRupiah(value) {
			if (!value) return "";
			return "Rp " + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
		},
		submit() {
			this.inputs.date_start = this.formattedDate(this.inputs.date_start);
			this.inputs.date_end = this.formattedDate(this.inputs.date_end);
			
			this.inputs.date_start_normal = this.formattedDate(this.inputs.date_start_normal);
			this.inputs.date_end_normal = this.formattedDate(this.inputs.date_end_normal);

			this.inputs.date_start_early_bird = this.formattedDate(this.inputs.date_start_early_bird);
			this.inputs.date_end_early_bird = this.formattedDate(this.inputs.date_end_early_bird);
			
			this.inputs.date_start_late_charges = this.formattedDate(this.inputs.date_start_late_charges);
			this.inputs.date_end_late_charges = this.formattedDate(this.inputs.date_end_late_charges);
			
			if (this.inputs.date_start_next_class) {
				this.inputs.date_start_next_class = this.formattedDate(this.inputs.date_start_next_class);
			}

			if (this.inputs.date_end_next_class) {
				this.inputs.date_end_next_class = this.formattedDate(this.inputs.date_end_next_class);
			}

			if (this.inputs.date_start_sc_conform) {
				this.inputs.date_start_sc_conform = this.formattedDate(this.inputs.date_start_sc_conform);
			}

			if (this.inputs.date_end_sc_conform) {
				this.inputs.date_end_sc_conform = this.formattedDate(this.inputs.date_end_sc_conform);
			}

			if (this.inputs.date_start_discontinue) {
				this.inputs.date_start_discontinue = this.formattedDate(this.inputs.date_start_discontinue);
			}

			if (this.inputs.date_end_discontinue) {
				this.inputs.date_end_discontinue = this.formattedDate(this.inputs.date_end_discontinue);
			}

			if (this.inputs.date_start_terminated) {
				this.inputs.date_start_terminated = this.formattedDate(this.inputs.date_start_terminated);
			}

			if (this.inputs.date_end_terminated) {
				this.inputs.date_end_terminated = this.formattedDate(this.inputs.date_end_terminated);
			}
			
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
		
			this.inputs = response.data;
			
			this.input_early_bird_discount = this.formatRupiah(this.inputs.early_bird_discount || 0);
			this.input_late_charges_fee = this.formatRupiah(this.inputs.late_charges_fee || 0);

			this.preloader = false;
		},
		formattedDate(payloadDate) {
			const originalDate = payloadDate;
			const date = new Date(originalDate);

			const year = date.getFullYear();
			const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
			const day = date.getDate().toString().padStart(2, "0");

			const formattedDate = `${year}-${month}-${day}`;

			return formattedDate;
		},
	},
	mounted() {
		this.input_early_bird_discount = this.formatRupiah(this.inputs.early_bird_discount);
		this.input_late_charges_fee = this.formatRupiah(this.inputs.late_charges_fee);
	},
};

</script>

<style scoped>
	::v-deep .modal-dialog {
		min-width: 900px;
	}
</style>